import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import visaicon from "../../assets/images/visaicon.png";
import email from "../../assets/images/email.svg";
import searchicon from "../../assets/images/searchicon.svg";
import {
    InvoiceGetList,
    InvoiceDownload,
    CreatePayment,
    InvoiceTransaction,
    PaymentMethodList,
} from "../../services/ReduxTookit/Slice/InvoiceRedux";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import {
    commonservices,
    getCardBrandImage,
    getNormalisedBrandName,
} from "../../services/CommonServices";
import viewaction from "../../assets/images/list.svg";
import Nodata from "../../component/common-component/Nodata";
import downloadAction2 from "../../assets/images/download2.svg";
import { toast } from "react-toastify";
import InvoiceTransactionListModal from "./InvoiceTransactionListModal";
import moment from "moment";
import { GetCurrentSubscription } from "../../services/ReduxTookit/Slice/SubscriptionsRedux";
import PaymentMethodSelection from "../PaymentMethodSelection";

const BillingManagementModel = ({ setShowRightPanel, OnlinePaymentDetails }) => {
    const dispatch = useDispatch();
    const [invoiceList, setInvoiceList] = useState([]);
    const [invoiceObj, setInvoiceObj] = useState(null);
    const [loading, setLoading] = useState(false);
    const [PaymentMethodData, setPaymentMethodData] = useState(null);
    const [showTransactionDetails, setShowTransactionDetails] = useState(false);
    const closeShowTransactionDetails = () => {
        setShowTransactionDetails(false);
    };

    const PlanDetails = useSelector(
        (state) =>
            state?.sunscriptionRedux?.GetCurrentSubscriptionData?.data?.data?.data
    );

    const GetPlanDetails = async () => {
        dispatch(GetCurrentSubscription());
    };
    const getInvoiceGetList = async () => {
        setLoading(true);

        // Fetch Payment Methods
        const bodyPaymentMethods = {};
        dispatch(PaymentMethodList(bodyPaymentMethods)).then((response) => {
            if (response?.payload?.isValidate) {
                let filteredpaymentMethod = response?.payload?.data?.data?.filter(
                    (item) => item.isprimary
                );
                setPaymentMethodData(filteredpaymentMethod[0]);
            }
            if (!response?.payload?.isValidate) {
                setPaymentMethodData(null);
            }
        });
        //   .finally(() => {
        //     setLoading(false);
        //   });

        const body = { invoicetype_term: "Workflow,Subscriptions Plan" };
        dispatch(InvoiceGetList(body))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    const sortedData = response?.payload?.data?.data
                        ?.slice()
                        ?.sort((a, b) => {
                            return new Date(b.dateofinvoice) - new Date(a.dateofinvoice);
                        });

                    if (sortedData?.length > 0 && sortedData[0]?.dateofinvoice) {
                        const newDate = new Date(sortedData[0]?.dateofinvoice);
                        newDate.setMonth(newDate.getMonth() + 1);
                        setInvoiceObj(moment(newDate).format("MMMM DD, YYYY"));
                    }

                    setInvoiceList(response?.payload?.data?.data);
                }
                if (!response?.payload?.isValidate) {
                    const newDate = new Date();
                    newDate.setMonth(newDate.getMonth() + 1);
                    newDate.setDate(2);
                    setInvoiceObj(moment(newDate).format("MMMM DD, YYYY"));
                    setInvoiceList([]);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const [invoiceLoading, setInvoiceLoading] = useState(false);

    const getInvoicePdf = async (invoiceNo) => {
        setInvoiceLoading(true);
        try {
            const body = { invoiceNo };
            const response = await dispatch(InvoiceDownload(body));

            const fileUrl = response?.payload?.data?.data; // Ensure it's a valid URL
            if (!fileUrl) {
                throw new Error("File URL not found");
            }

            // Open in a new tab to prevent opening in the same window
            window.open(fileUrl, "_blank");
        } catch (error) { }
        setInvoiceLoading(false);
    };

    const [PaymentPopup, setPaymentPopup] = useState({
        show: false,
        invoiceitem: null,
        itemtype: "Workflow Invoice",
    });

    const fnPaymentSelection = async (item) => {
        setPaymentPopup({
            show: true,
            invoiceitem: item,
            itemtype: "Workflow Invoice",
        });
    };

    const payloadRef = useRef();

    useEffect(() => {
        getInvoiceGetList();
        GetPlanDetails();
    }, []);

    useEffect(() => {
        const storedInvoiceData = sessionStorage.getItem("reopen_bill_payment_invoice");
        if (storedInvoiceData && !OnlinePaymentDetails?.isshow) {
            try {
                const parsed = JSON.parse(storedInvoiceData);
                const invoiceItem = parsed?.item || parsed;
                const itemType = parsed?.itemtype || "Workflow Invoice";
                if (invoiceItem) {
                    getInvoiceGetList();
                    setPaymentPopup({
                        show: true,
                        invoiceitem: invoiceItem,
                        itemtype: itemType,
                    });
                }
            } catch (e) {
                console.error("Failed to parse reopen_bill_payment_invoice", e);
            } finally {
                sessionStorage.removeItem("reopen_bill_payment_invoice");
            }
        }
    }, [OnlinePaymentDetails?.isshow]);

    return (
        <div className="bcm-main">
            <Row>
                <Col xl={4}>
                    {loading ? (
                        <Row>
                            <Loader type={LoaderType.PaymentNextBilling} count={1} />
                        </Row>
                    ) : (
                        <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                            <div className="payment-method-title">
                                <h2>Next Billing</h2>
                            </div>
                            <div className="payment-method-detail-billing mt-20">
                                <h2>{invoiceObj && invoiceObj}</h2>
                            </div>
                        </div>
                    )}
                </Col>
                <Col xl={4}>
                    <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                        <div className="payment-method-title">
                            <h2>Plan</h2>
                        </div>
                        <div className="payment-method-detail-billing">
                            <div className="payment-method-detail-billing-left">
                                <div className="payment-method-detail-billing-price">
                                    <p>
                                        ${PlanDetails?.price}
                                        <span>
                                            {" "}
                                            Per{" "}
                                            {PlanDetails?.noofmonth === 1
                                                ? "Month"
                                                : PlanDetails?.noofmonth === 3
                                                    ? "3 Month"
                                                    : PlanDetails?.noofmonth === 6
                                                        ? "6 Month"
                                                        : "Year"}
                                        </span>
                                    </p>
                                </div>
                                <div className="payment-method-detail-billing-active d-flex gap-2">
                                    <p>{PlanDetails?.subscriptionname}</p>
                                    <a href="#">
                                        {" "}
                                        <span className="greendot"></span> <span>Active</span>
                                    </a>
                                </div>
                            </div>
                            <div className="payment-method-detail-billing-right">
                                <Button
                                    className="blue-btn d-inline-block  upgrade-plan cursor-pointer"
                                    onClick={() => setShowRightPanel("membership")}
                                >
                                    Upgrade Plan
                                </Button>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xl={4}>
                    {loading ? (
                        <Row>
                            <Loader type={LoaderType.PaymentMethodSingleCard} count={1} />
                        </Row>
                    ) : (
                        <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                            <div className="payment-method-title">
                                <h2>Payment Method</h2>
                                <p
                                    className="cursor-pointer"
                                    onClick={() => {
                                        setShowRightPanel("paymentmethod");
                                    }}
                                >
                                    Manage
                                </p>
                            </div>
                            {PaymentMethodData ? (
                                <div className="payment-method-detail">
                                    <div className="payment-method-detail-img">
                                        {PaymentMethodData?.display_brand &&
                                            getCardBrandImage(PaymentMethodData?.display_brand)}
                                    </div>
                                    <div className="payment-method-detail-data">
                                        <div className="visa-title ">
                                            <h4>
                                                {" "}
                                                {getNormalisedBrandName(
                                                    PaymentMethodData?.display_brand
                                                )}{" "}
                                                Ending with {PaymentMethodData?.methodnumber}{" "}
                                            </h4>
                                            <span className="cursor-pointer bg-success text-white">
                                                <b>Primary</b>
                                            </span>
                                        </div>
                                        <p>
                                            Expires{" "}
                                            {`${PaymentMethodData?.exp_month
                                                }/${PaymentMethodData?.exp_year?.substr(
                                                    PaymentMethodData?.exp_year?.length - 2,
                                                    PaymentMethodData?.exp_year?.length
                                                )}`}
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <small>Payment method not available.</small>
                            )}
                        </div>
                    )}
                </Col>
            </Row>
            <div className="table-wrapper-main setting-table-main">
                <div className="profile-common-title"></div>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Invoice#</th>
                            <th className="text-start">Billing Date</th>
                            <th className="text-start">Due Date</th>
                            <th className="">Status</th>
                            <th className="text-end">Amount</th>

                            <th className="text-end sticky-actions">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <Loader type={LoaderType.TableRow} count={6} nooftd={6} />
                        ) : (
                            <>
                                {invoiceList?.length > 0 ? (
                                    <>
                                        {invoiceList?.map((item) => {
                                            return (
                                                <tr key={item?.invoiceid}>
                                                    <td className="text-start">{item?.invoiceno}</td>
                                                    <td className="text-start">
                                                        {item?.dateofinvoice
                                                            ? commonservices.getDateInFormatCustom(
                                                                item?.dateofinvoice,
                                                                null,
                                                                "MM/DD/yyyy"
                                                            )
                                                            : ""}
                                                    </td>
                                                    <td className="text-start">
                                                        {item?.invoiceduedate
                                                            ? commonservices.getDateInFormatCustom(
                                                                item?.invoiceduedate,
                                                                null,
                                                                "MM/DD/yyyy"
                                                            )
                                                            : ""}
                                                    </td>
                                                    <td>{commonservices.getStatus(item?.status_term)}</td>
                                                    <td className="text-end">
                                                        {item?.invoicefinalamount > 0
                                                            ? `$${item?.invoicefinalamount?.toFixed(2)}`
                                                            : "Free"}
                                                    </td>
                                                    <td className="sticky-actions">
                                                        <div className="all-actions">
                                                            <img
                                                                src={downloadAction2}
                                                                title="Download"
                                                                alt="Download"
                                                                onClick={() => {
                                                                    getInvoicePdf(item?.invoiceno);
                                                                }}
                                                            />
                                                            {item?.invoicetype_term.toUpperCase() === "Workflow" && (
                                                                <img
                                                                    title="View Transaction"
                                                                    src={viewaction}
                                                                    alt="View Transaction"
                                                                    onClick={() => {
                                                                        payloadRef.current = {
                                                                            associationid: item?.invoiceid,
                                                                            associationtype_term: "Workflow Invoice",
                                                                            invoiceno: item?.invoiceno,
                                                                        };
                                                                        setShowTransactionDetails(true);
                                                                    }}
                                                                />
                                                            )}

                                                            {item?.status_term.toUpperCase() !== "PAID" && (
                                                                <button
                                                                    class="blue-btn btn-sm"
                                                                    onClick={() => fnPaymentSelection(item)}
                                                                >
                                                                    Pay
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan={100}>
                                            <Nodata />
                                        </td>
                                    </tr>
                                )}
                            </>
                        )}
                    </tbody>
                </Table>
            </div>

            {showTransactionDetails && (
                <InvoiceTransactionListModal
                    showModal={showTransactionDetails}
                    closeModal={closeShowTransactionDetails}
                    payload={payloadRef.current}
                />
            )}

            {
                PaymentPopup && PaymentPopup.show && PaymentPopup.invoiceitem &&
                <PaymentMethodSelection
                    show={PaymentPopup.show}
                    item={PaymentPopup.invoiceitem}
                    itemtype={PaymentPopup.itemtype || "Workflow Invoice"}
                    returnpath="/management-listing"
                    onPaymentSuccess={() => {
                        getInvoiceGetList();
                    }}
                    onHide={(e) => {
                        setPaymentPopup({
                            show: false,
                            invoiceitem: null,
                            itemtype: "Workflow Invoice",
                        });
                        getInvoiceGetList();
                    }}
                />
            }

        </div>
    );
};

export default BillingManagementModel;
